"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericConfirmationCard = void 0;
const adaptivecards_1 = require("adaptivecards");
const DoneAction_1 = require("../../survey/actions/DoneAction");
const acUtils_1 = require("../utils/acUtils");
const CardHelper_1 = require("../utils/CardHelper");
const GenericConfirmationCard = (message, subTitle, applicationType, primaryActionLabel, secondaryActionLabel, submitCommand, imageType = "WARN", showPrimaryAction = true) => {
    const card = CardHelper_1.CardHelper.newCard();
    card.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.Image, {
        spacing: adaptivecards_1.Spacing.Large,
        horizontalAlignment: adaptivecards_1.HorizontalAlignment.Center,
        url: (0, CardHelper_1.getImageCardUrl)(imageType, applicationType),
    }));
    card.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        color: adaptivecards_1.TextColor.Default,
        horizontalAlignment: adaptivecards_1.HorizontalAlignment.Center,
        size: adaptivecards_1.TextSize.Large,
        text: message,
        weight: adaptivecards_1.TextWeight.Bolder,
        wrap: true,
    }));
    card.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        color: adaptivecards_1.TextColor.Default,
        horizontalAlignment: adaptivecards_1.HorizontalAlignment.Center,
        size: adaptivecards_1.TextSize.Default,
        text: subTitle,
        weight: adaptivecards_1.TextWeight.Default,
        wrap: true,
    }));
    const fillerColumnSet = CardHelper_1.CardHelper.create(adaptivecards_1.ColumnSet, {
        height: "stretch",
        spacing: adaptivecards_1.Spacing.ExtraLarge,
        minPixelHeight: 10,
    });
    fillerColumnSet.addColumn((0, acUtils_1.createFillerColumn)());
    card.addItem(fillerColumnSet);
    const buttonsColumnSet = CardHelper_1.CardHelper.create(adaptivecards_1.ColumnSet, {
        height: "stretch",
        spacing: adaptivecards_1.Spacing.ExtraLarge,
    });
    buttonsColumnSet.addColumn((0, acUtils_1.createFillerColumn)());
    const actionSet = CardHelper_1.CardHelper.create(adaptivecards_1.ActionSet, {
        horizontalAlignment: adaptivecards_1.HorizontalAlignment.Right,
        spacing: adaptivecards_1.Spacing.ExtraLarge,
    });
    actionSet.addAction((0, DoneAction_1.DoneAction)(secondaryActionLabel));
    if (showPrimaryAction) {
        actionSet.addAction(CardHelper_1.CardHelper.create(adaptivecards_1.SubmitAction, {
            title: primaryActionLabel,
            isPrimary: true,
            data: submitCommand.toTaskFetchCommand(),
        }));
    }
    const buttonsColumn = new adaptivecards_1.Column("auto");
    buttonsColumn.addItem(actionSet);
    buttonsColumnSet.addColumn(buttonsColumn);
    card.addItem(buttonsColumnSet);
    return card;
};
exports.GenericConfirmationCard = GenericConfirmationCard;
//# sourceMappingURL=GenericConfirmationCard.js.map